export default function(number, x, s, c) {
  const num = number === null || number === undefined ? '' : number.toString();
  const re = `\\d(?=(\\d{${x || 3}})+${num.indexOf(c) !== -1 ? '\\D' : '$'})`;
  return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), `$&${s || ','}`);
}
